var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-card"},[_c('div',{ref:("refYandexMap" + _vm.strKey),attrs:{"id":"CardsCarouselBlockMapCard"}}),_vm._v(" "),_c('nuxt-link',{staticClass:"btn btn-primary",attrs:{"to":"/kontakty"}},[_vm._v("Другие салоны")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }